import {RouterProps} from "../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Post from "./Post";
import Detail from "./Detail";
import Edit from "./Edit";
import HistoryRouter from "./history/HistoryRouter";

export default function RankRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:userRankId'} element={<Detail {...props} />} />
            <Route path={'/:userRankId/edit'} element={<Edit {...props} />} />
            <Route path={'/histories/*'} element={<HistoryRouter {...props} />} />
        </Routes>
    </>
}